(() => {
  const productMedium = document.querySelector('.product--medium');
  if (productMedium) {
    new IntersectionObserver(
      ([entry]) => document.body.classList.toggle('scrolled-product', !entry.isIntersecting),
      { rootMargin: '0px' }
    ).observe(productMedium);
  }

  const tiles = document.querySelectorAll('.tile');
  if (tiles.length) {
    const tileObserver = new IntersectionObserver(
      entries => entries.forEach(e => e.target.classList.toggle('inView', e.isIntersecting)),
      { rootMargin: '20px 0px' }
    );
    tiles.forEach(t => tileObserver.observe(t));
  }
})();
